// The router singleton, extracted out of main.tsx so it can be imported
// without triggering the app's render — session-expiry.ts needs to call
// .navigate() on it from api.ts's plain fetch wrapper, not from a component.

import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
